import React from "react";
import { Topbar } from "@components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { PRIVATE_ROUTE, } from '@router/route.constants';
import { useSelector } from "react-redux";

const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
`;

const Rules = styled.div`
  color: #9b92bb;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px; /* 207.692% */

  user-select: none; /* Disable text selection */
  -webkit-user-select: none; /* For Safari */
  -moz-user-select: none; /* For Firefox */
  -ms-user-select: none; /* For Internet Explorer/Edge */
  -webkit-touch-callout: none; /* Disable context menu on touch devices */
  -moz-touch-callout: none;
  -ms-touch-callout: none;
  -webkit-touch-callout: none;
`;

const PromoTerms = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userPreferedLanguage = localStorage.getUserPreferedLanguage();
    const { promocode_rule } = useSelector((state) => state.app.settings);

    const rule =
        userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK
            ? promocode_rule?.text_en
            : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
                ? promocode_rule?.text_mm
                : promocode_rule?.text_ch;

    const goBack = () => {
        navigate(`/${PRIVATE_ROUTE.PROMO_CODE_HISTORY}`);
    };

    return (
        <>
            <Topbar title={t("common.termsAndConditions")} goBack={goBack} />
            <RootContainer>
                <Rules dangerouslySetInnerHTML={{ __html: rule }} />
            </RootContainer>
        </>
    );
};

export default PromoTerms;
